<ol>
  @for (step of steps(); track step) {
    <li [ngClass]="{ 'done': step.id <= currentStep().id}"></li>
  }
</ol>
